import maplibregl, { Map as MapLibreMap } from 'maplibre-gl';

export type Theme = 'dark' | 'light';

const STYLES: Record<Theme, string> = {
  dark: 'https://basemaps.cartocdn.com/gl/dark-matter-gl-style/style.json',
  light: 'https://basemaps.cartocdn.com/gl/positron-gl-style/style.json',
};

export const styleUrl = (theme: Theme): string => STYLES[theme];

export function createMap(
  container: HTMLElement,
  theme: Theme,
  center: [number, number],
  zoom: number,
): MapLibreMap {
  const map = new maplibregl.Map({
    container,
    style: styleUrl(theme),
    center,
    zoom,
    minZoom: 4,
    maxZoom: 18,
    attributionControl: false,
    dragRotate: true,
    // The vehicle canvas is redrawn from `map.project()`, so we need the
    // rendered frame and our overlay to stay in lock-step.
    fadeDuration: 120,
  });

  // The CARTO style ships its own attribution; adding our own would double it.
  map.addControl(new maplibregl.AttributionControl({ compact: true }), 'bottom-right');
  map.addControl(
    new maplibregl.NavigationControl({ showCompass: true, visualizePitch: true }),
    'bottom-right',
  );
  map.addControl(
    new maplibregl.GeolocateControl({
      positionOptions: { enableHighAccuracy: true },
      trackUserLocation: true,
    }),
    'bottom-right',
  );
  map.addControl(new maplibregl.ScaleControl({ maxWidth: 90, unit: 'metric' }), 'bottom-right');

  return map;
}
